import { gql } from "@apollo/client";

export const GET_JOBS = gql`
	query GetJobs {
		countcJobs {
			JobID
			LotID
			Size
			Botanical
			StartWeek
			ReadyWeek
			Quantity
			LocationID
			Plan
			Customer
			CompletedQuantity
			AllottedMinutes
		}
	}
`;

export const SET_JOB = gql`
	mutation CreateCountSummary($input: COUNTcArgsCreateCountSummary!) {
		countcCreateCountSummary(input: $input) {
			DeviceID
			CountSummaryID
			Quantity
			JobID
			Posted
			CreateDate
			UpdateDate
			LotID
			LocationID
			People
			AllottedMinutes
			Target
			Botanical
			CompletedQuantity
			Customer
			Plan
			TargetQuantity
			ReadyWeek
			Size
			StartWeek
		}
	}
`;

export const POST_COUNT = gql`
	mutation PostCount($input: COUNTcArgsPostCount!) {
		countcPostCount(input: $input) {
			DeviceID
			CountSummaryID
			Quantity
			JobID
			Posted
			CreateDate
			UpdateDate
			LotID
			LocationID
			People
			AllottedMinutes
			Target
			Botanical
			CompletedQuantity
			Plan
			TargetQuantity
			ReadyWeek
			Size
			StartWeek
		}
	}
`;

export const UPDATE_SUMMARY = gql`
	mutation UpdateSummary($input: COUNTcArgsUpdateSummary!) {
		countcUpdateSummary(input: $input) {
			DeviceID
			CountSummaryID
			Quantity
			JobID
			Posted
			CreateDate
			UpdateDate
			LotID
			LocationID
			People
			AllottedMinutes
			Target
			Botanical
			CompletedQuantity
			Customer
			Plan
			TargetQuantity
			ReadyWeek
			Size
			StartWeek
		}
	}
`;

export const GET_DEVICE = gql`
	query GetDevice($DeviceID: Int!) {
		countcDevice(DeviceID: $DeviceID) {
			DeviceID
			Title
			MacAddress
			IpAddress
			DeviceTime
			CreateDate
			UpdateDate
			TZ
			BreakBeamMin
			UpdateInterval
			Debug
			Demo
			Version
		}
		countcCountSummary(DeviceID: $DeviceID) {
			DeviceID
			CountSummaryID
			Quantity
			JobID
			Posted
			CreateDate
			UpdateDate
			LotID
			LocationID
			People
			AllottedMinutes
			Target
			Botanical
			CompletedQuantity
			Customer
			Plan
			TargetQuantity
			ReadyWeek
			Size
			StartWeek
		}
	}
`;

export const GET_DEVICES = gql`
	query GetDevices {
		countcDevices {
			DeviceID
			Title
			MacAddress
			IpAddress
			DeviceTime
			CreateDate
			UpdateDate
			TZ
			BreakBeamMin
			UpdateInterval
			Debug
			Demo
			Version
		}
		countcCountSummaries {
			DeviceID
			CountSummaryID
			Quantity
			JobID
			Posted
			CreateDate
			UpdateDate
			LotID
			Botanical
			CompletedQuantity
			Customer
			Plan
			TargetQuantity
			ReadyWeek
			Size
			StartWeek
		}
	}
`;

export const GET_LOCATIONS = gql`
	query GetLocations {
		countcLocations {
			ID
			Type
			Location
			Level
			HierarchicalPath
		}
	}
`;

export const GET_COUNT_HISTORY = gql`
	query GetCountHistory($DeviceID: Int!, $CountSummaryID: Int!) {
		countcCountHistory(DeviceID: $DeviceID, CountSummaryID: $CountSummaryID) {
			DeviceID
			Quantity
			CountSummaryID
			CreateDate
		}
	}
`;

export const SUMMARY_CHANGE_SUBSCRIPTION = gql`
	subscription OnSummaryChange($DeviceID: Int!, $CountSummaryID: Int!, $JobID: Int!) {
		countcCountSummaryChanged(DeviceID: $DeviceID, CountSummaryID: $CountSummaryID, JobID: $JobID) {
			DeviceID
			CountSummaryID
			Quantity
			JobID
			Posted
			CreateDate
			UpdateDate
			LotID
			LocationID
			People
			AllottedMinutes
			Target
			Botanical
			CompletedQuantity
			Customer
			Plan
			TargetQuantity
			ReadyWeek
			Size
			StartWeek
		}
	}
`;
